export enum OSAffectedControlType {
  Imei = 1,
  Storage,
}

export enum TradeInImeiErrorType {
  ImeiAlreadyInUseByActiveMobilBytteAgreement = 'ImeiAlreadyInUseByActiveMobilBytteAgreement',
  ImeiIsAlreadyInUseOnAnActiveTradeInProcess = 'ImeiIsAlreadyInUseOnAnActiveTradeInProcess',
  InvalidImei = 'InvalidImei',
  ProductIsNotAvailableForTradeIn = 'ProductIsNotAvailableForTradeIn',
  NoError = 'NoError',
}
